import "regenerator-runtime/runtime.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import addWishlistItemMutation from '~/graphql/wishlist/addWishlistItem.gql';
import deleteWishlistItemMutation from '~/graphql/wishlist/deleteWishlistItem.gql';
import wishlistQuery from '~/graphql/wishlist/wishlist.gql';
import { isValidToken } from '~/helpers/connection-helper';
function fetchDetailedWishlist(_x, _x2) {
  return _fetchDetailedWishlist.apply(this, arguments);
}
function _fetchDetailedWishlist() {
  _fetchDetailedWishlist = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref, _ref2) {
    var app, getters, offset, limit, isPrivateSales, locale, _yield$app$apolloProv, data;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          app = _ref.app, getters = _ref.getters;
          offset = _ref2.offset, limit = _ref2.limit, isPrivateSales = _ref2.isPrivateSales;
          if (!isValidToken()) {
            _context.next = 9;
            break;
          }
          locale = getters['i18n/locale'].iso;
          _context.next = 6;
          return app.apolloProvider.defaultClient.query({
            fetchPolicy: 'network-only',
            query: wishlistQuery,
            context: {
              headers: {
                Authorization: "Bearer ".concat(localStorage.getItem('MDM_ACCESS_TOKEN'))
              }
            },
            variables: {
              locale: locale,
              detailed: true,
              offset: offset,
              limit: limit,
              isPrivateSales: isPrivateSales
            }
          });
        case 6:
          _yield$app$apolloProv = _context.sent;
          data = _yield$app$apolloProv.data;
          return _context.abrupt("return", data && data.wishlist);
        case 9:
          return _context.abrupt("return", null);
        case 10:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _fetchDetailedWishlist.apply(this, arguments);
}
function fetchWishlist(_x3) {
  return _fetchWishlist.apply(this, arguments);
}
function _fetchWishlist() {
  _fetchWishlist = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(context) {
    var detailed,
      locale,
      response,
      _args2 = arguments;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          detailed = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : false;
          if (!isValidToken()) {
            _context2.next = 7;
            break;
          }
          locale = context.state.i18n.currentLocale;
          _context2.next = 5;
          return context.app.apolloProvider.defaultClient.query({
            fetchPolicy: 'network-only',
            query: wishlistQuery,
            context: {
              headers: {
                Authorization: "Bearer ".concat(localStorage.getItem('MDM_ACCESS_TOKEN'))
              }
            },
            variables: {
              locale: locale.iso,
              detailed: detailed
            }
          });
        case 5:
          response = _context2.sent;
          return _context2.abrupt("return", response.data);
        case 7:
          return _context2.abrupt("return", null);
        case 8:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _fetchWishlist.apply(this, arguments);
}
function addWishlistItem(_x4, _x5) {
  return _addWishlistItem.apply(this, arguments);
}
function _addWishlistItem() {
  _addWishlistItem = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(context, reference) {
    var response;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          if (!isValidToken()) {
            _context3.next = 5;
            break;
          }
          _context3.next = 3;
          return context.app.apolloProvider.defaultClient.mutate({
            mutation: addWishlistItemMutation,
            context: {
              headers: {
                Authorization: "Bearer ".concat(localStorage.getItem('MDM_ACCESS_TOKEN'))
              }
            },
            variables: {
              reference: reference
            }
          });
        case 3:
          response = _context3.sent;
          return _context3.abrupt("return", response.data);
        case 5:
          return _context3.abrupt("return", null);
        case 6:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return _addWishlistItem.apply(this, arguments);
}
function deleteWishlistItem(_x6, _x7) {
  return _deleteWishlistItem.apply(this, arguments);
}
function _deleteWishlistItem() {
  _deleteWishlistItem = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(context, reference) {
    var response;
    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          if (!isValidToken()) {
            _context4.next = 5;
            break;
          }
          _context4.next = 3;
          return context.app.apolloProvider.defaultClient.mutate({
            mutation: deleteWishlistItemMutation,
            context: {
              headers: {
                Authorization: "Bearer ".concat(localStorage.getItem('MDM_ACCESS_TOKEN'))
              }
            },
            variables: {
              reference: reference
            }
          });
        case 3:
          response = _context4.sent;
          return _context4.abrupt("return", response.data);
        case 5:
          return _context4.abrupt("return", null);
        case 6:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return _deleteWishlistItem.apply(this, arguments);
}
export { fetchDetailedWishlist, fetchWishlist, addWishlistItem, deleteWishlistItem };